import { request } from './request'

function login (data) {
  return request({
    method: 'POST',
    url: '/api/v2/user/login',
    data
  })
}

const account = {
  login
}

export default account